import { ActionType } from 'typesafe-actions';
import * as settingsActionCreators from './actions';
import reducer from './reducer';

export default reducer;

export const actions = settingsActionCreators;

export * from './types';
export type SettingsActions = ActionType<typeof settingsActionCreators>;
